import { useQuery } from "@tanstack/react-query";
import { apiCall } from "../lib/apiClient";

/** tenantAdmin read-only rozpočty střediska + per-karta kalkulace (princip #3). */

export interface TenantBudgetSummary {
  budget_id: string;
  billing_group_code: string;
  month: string;
  status: string;
  total_amount_kc: string;
  total_amount_eur: string;
  eur_advisory: boolean;
  approved_at: string | null;
}

export interface TenantBudgetsResponse {
  budgets: TenantBudgetSummary[];
}

export interface TenantBudgetCardItem {
  fuel_card_id: string;
  card_label: string | null;
  card_number_display: string | null;
  holder_label: string | null;
  tx_count: number;
  sum_kc: string;
  sum_eur: string;
}

export interface TenantBudgetDetail {
  budget_id: string;
  billing_group_code: string;
  month: string;
  status: string;
  total_amount_kc: string;
  total_amount_eur: string;
  eur_advisory: boolean;
  approved_at: string | null;
  items: TenantBudgetCardItem[];
}

export function useTenantBudgets() {
  return useQuery({
    queryKey: ["tenant", "budgets"] as const,
    queryFn: () => apiCall<TenantBudgetsResponse>("/api/tenant/budgets"),
    staleTime: 60_000,
  });
}

export function useTenantBudgetDetail(budgetId: string) {
  return useQuery({
    queryKey: ["tenant", "budgets", "detail", budgetId] as const,
    queryFn: () => apiCall<TenantBudgetDetail>(`/api/tenant/budgets/${budgetId}`),
    staleTime: 60_000,
  });
}
